import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "vertical-barchart",
  "use": "vertical-barchart-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"vertical-barchart\"><path d=\"M26 28V2h-4v26h-4V9h-4v19h-4V7H6v21H2v2h28v-2h-4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/vertical-barchart.svg
// module id = s0IM
// module chunks = 39 44